import type { ButtonHTMLAttributes, ReactNode } from 'react';
import {
  ButtonLeadingIcon,
  resolveButtonIcon,
  type ButtonIconKey,
} from '@/lib/button-leading-icon';
import { cn } from '@/lib/utils';

export type NativeButtonWithIconProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon?: ButtonIconKey | 'auto' | false;
  actionKey?: string;
  children?: ReactNode;
};

export function NativeButtonWithIcon({
  className,
  icon = 'auto',
  actionKey,
  children,
  type = 'button',
  ...props
}: NativeButtonWithIconProps) {
  const resolvedIcon = resolveButtonIcon({ icon, actionKey, children });
  return (
    <button
      type={type}
      className={cn(resolvedIcon && 'inline-flex items-center gap-2', className)}
      {...props}
    >
      {resolvedIcon ? <ButtonLeadingIcon name={resolvedIcon} size={16} /> : null}
      {children}
    </button>
  );
}
